// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.add-button[data-v-638f5395] {\r\n  color: #2cb484;\r\n  cursor: pointer;\r\n  font-size: 16px;\n}\n.custom-radio[data-v-638f5395] {\r\n  -webkit-transform: scale(2.1);\r\n          transform: scale(2.1);\r\n  margin-left: 2%;\n}\r\n", ""]);
// Exports
module.exports = exports;
